webpackJsonp([5],{

/***/ 1047:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(1155);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b9226a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1226);
function injectStyle (ssrContext) {
  __webpack_require__(1215)
}
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b9226a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  baseURL: "https://centralize.maeriminterfood.com",
  baseURLV2: "https://marim-mis-api.maeriminterfood.com"
  // baseURLV2: 'https://marim-api-test.undefined.co.th:4439'
  // baseURLV2: "http://localhost:6100"
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1104);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  updateSale: function updateSale(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/sale/updatesalesdetails', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  branch: function branch(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/branch', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  deleteHoldBil: function deleteHoldBil(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/sale/deleteHoldbill', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUser: function roleUser(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUser', null, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserDelete: function roleUserDelete(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserDelete', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserGetCode: function roleUserGetCode(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserGetCode', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserGet: function roleUserGet(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserGet', null, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserUpdate: function roleUserUpdate(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserUpdate', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserInsert: function roleUserInsert(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserInsert', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getRemainStock: function getRemainStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/item/getRemainStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  changeStock: function changeStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/item/changeStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getItemGroup: function getItemGroup(success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/dashboard/getItemGroup', null).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slider__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__breadcrumb__ = __webpack_require__(1224);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_0__header__["a" /* default */],
    FooterView: __WEBPACK_IMPORTED_MODULE_2__footer__["a" /* default */],
    SliderView: __WEBPACK_IMPORTED_MODULE_1__slider__["a" /* default */],
    BreadcrumbView: __WEBPACK_IMPORTED_MODULE_3__breadcrumb__["a" /* default */]
  },
  mounted: function mounted() {
    this.checkUser();
  }
});

/***/ }),

/***/ 1156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service_undefined__ = __webpack_require__(1110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      notiData: []
    };
  },
  created: function created() {
    // get data from here
    this.getRemainStock();
  },

  methods: {
    logout: function logout() {
      this.$store.state.isLoading = true;
      this.$store.commit("clearState");
      window.location = "/login";
    },
    getRemainStock: function getRemainStock() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_service_undefined__["a" /* default */].getRemainStock({
        branchName: ""
      }, function (results) {
        if (results.data.result.length > 0) {
          _this.notiData = results.data.result;
        }
      }, function (errors) {
        _this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
      });
    },
    linkReceived: function linkReceived(item, branchName) {
      this.$store.state.branchName = branchName;
      this.$router.push(item);
    }
  }
});

/***/ }),

/***/ 1215:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1216);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("13dce605", content, true, {});

/***/ }),

/***/ 1216:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".btn-bottom{background:#000;color:#fff;width:50px;height:50px;position:fixed;bottom:0;right:15px;border-radius:5px;opacity:.4;filter:alpha(opacity=40);cursor:pointer;font-size:40px;text-align:center;line-height:50px}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/components/main.vue"],"names":[],"mappings":"AACA,YACE,gBAAiB,AACjB,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,SAAY,AACZ,WAAY,AACZ,kBAAmB,AACnB,WAAa,AACb,yBAA0B,AAC1B,eAAgB,AAChB,eAAgB,AAChB,kBAAmB,AACnB,gBAAkB,CACnB","file":"main.vue","sourcesContent":["\n.btn-bottom {\n  background: #000;\n  color: #fff;\n  width: 50px;\n  height: 50px;\n  position: fixed;\n  bottom: 0px;\n  right: 15px;\n  border-radius: 5px;\n  opacity: 0.4;\n  filter: alpha(opacity=40);\n  cursor: pointer;\n  font-size: 40px;\n  text-align: center;\n  line-height: 50px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__(1156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446c5b22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(1220);
function injectStyle (ssrContext) {
  __webpack_require__(1218)
}
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-446c5b22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446c5b22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1218:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1219);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("4738e58e", content, true, {});

/***/ }),

/***/ 1219:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".noti .fa-bell[data-v-446c5b22]{font-size:22px}.noti .dropdown-header[data-v-446c5b22]{text-align:left!important}.noti .dropdown-header[data-v-446c5b22]:hover{background-color:#17a2b8}.title[data-v-446c5b22]{font-size:13px}.text-date[data-v-446c5b22]{color:#cbd1d7;font-size:10px}.noti-dot[data-v-446c5b22]{font-size:5px;position:absolute;right:0}.noti-items[data-v-446c5b22]{max-height:20rem;overflow-y:scroll}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/components/header.vue"],"names":[],"mappings":"AACA,gCACE,cAAgB,CACjB,AACD,wCACE,yBAA4B,CAC7B,AACD,8CACE,wBAA0B,CAC3B,AACD,wBACE,cAAgB,CACjB,AACD,4BACE,cAAe,AACf,cAAgB,CACjB,AACD,2BACE,cAAe,AACf,kBAAmB,AACnB,OAAW,CACZ,AACD,6BACE,iBAAkB,AAClB,iBAAmB,CACpB","file":"header.vue","sourcesContent":["\n.noti .fa-bell[data-v-446c5b22] {\n  font-size: 22px;\n}\n.noti .dropdown-header[data-v-446c5b22] {\n  text-align: left !important;\n}\n.noti .dropdown-header[data-v-446c5b22]:hover {\n  background-color: #17a2b8;\n}\n.title[data-v-446c5b22] {\n  font-size: 13px;\n}\n.text-date[data-v-446c5b22] {\n  color: #cbd1d7;\n  font-size: 10px;\n}\n.noti-dot[data-v-446c5b22] {\n  font-size: 5px;\n  position: absolute;\n  right: 0px;\n}\n.noti-items[data-v-446c5b22] {\n  max-height: 20rem;\n  overflow-y: scroll;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"main-header navbar navbar-expand navbar-dark navbar-info"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('div',{staticClass:"noti  align-items-center d-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"user-panel mt-0 pb-0 mb-0 d-flex",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[(_vm.notiData && _vm.notiData.length > 0)?_c('div',{staticClass:"noti-dot text-red badge badge-pill badge-danger"},[_vm._v("\n            .\n          ")]):_vm._e(),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.notiData && _vm.notiData.length > 0)?_c('div',{staticClass:"dropdown-menu dropdown-menu-lg dropdown-menu-right mt-4 noti-items"},[_c('span',{staticClass:"dropdown-item dropdown-header text-white",staticStyle:{"background-color":"#17a2b8","font-size":"15px"}},[_vm._v("แจ้งเตือน")]),_vm._v(" "),_vm._l((_vm.notiData),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.linkReceived(item.url,item.branchName)}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"text-date"},[_vm._v(_vm._s(item.date))])])])})],2):_vm._e()])]),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"user-panel mt-0 pb-0 mb-0 d-flex",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"info"},[_c('b',{staticClass:"d-block text-white"},[_vm._v(_vm._s(_vm.$store.state.user.username))])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-lg dropdown-menu-right mt-4"},[_c('span',{staticClass:"dropdown-item dropdown-header"},[_vm._v("ตำแหน่ง: "+_vm._s(_vm.$store.state.user.role_name))]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$router.push('/profile')}}},[_c('i',{staticClass:"fas fa-user-circle mr-3"}),_vm._v(" ข้อมูลส่วนตัว\n        ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.logout}},[_c('i',{staticClass:"fas fa-sign-out-alt mr-3"}),_vm._v(" ออกจากระบบ\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"data-widget":"pushmenu","href":"#"}},[_c('i',{staticClass:"fas fa-bars"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-white"},[_c('i',{staticClass:"fas fa-bell"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{staticClass:"img-circle elevation-2",attrs:{"src":__webpack_require__(1221),"alt":"User Image"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1221:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/avatar04.f2dd257.png";

/***/ }),

/***/ 1222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469e8906_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__(1223);
var normalizeComponent = __webpack_require__(193)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469e8906_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('strong',[_vm._v("Copyright © "),_c('a',{attrs:{"href":"/"}},[_vm._v("Maeriminterfood Co.,Ltd")]),_vm._v(" 2022 ")]),_vm._v("\n  All rights reserved.\n  "),_c('div',{staticClass:"float-right d-none d-sm-inline-block"},[_c('b',[_vm._v("Version")]),_vm._v(" 1.0.0")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_087914a7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__ = __webpack_require__(1225);
var normalizeComponent = __webpack_require__(193)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_087914a7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header pb-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-sm-6"},[_c('h1',{staticClass:"m-0 text-dark"},[_vm._v(_vm._s(_vm.$route.meta.title))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('ol',{staticClass:"breadcrumb float-sm-right"},[_vm._m(0),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v(_vm._s(_vm.$route.name))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('HeaderView'),_vm._v(" "),_c('SliderView'),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('BreadcrumbView'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('back-top',{staticClass:"btn-bottom",attrs:{"bottom":"5%","right":"2%","slow":1}},[_c('i',{staticClass:"fas fa-chevron-up"})])],1),_vm._v(" "),_c('FooterView'),_vm._v(" "),_c('aside',{staticClass:"control-sidebar control-sidebar-dark"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.917fd4f428b682dfc52f.js